const verifyBookingRescheduleAvailabilityData = (state = null, action) => {
  if (action.type === "SET_VERIFY_BOOKING_RESCHEDULE_AVAILABILITY_DATA") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_VERIFY_BOOKING_RESCHEDULE_AVAILABILITY_DATA": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default verifyBookingRescheduleAvailabilityData;
